import React from 'react';
import { Card, Image, Transition } from 'semantic-ui-react';

import Base from 'src/components/coreUI/Card/Base';
import company_default from 'src/assets/default_company.png';
import { Calendar, CommentBubble, Like, User } from 'src/components/icons';
import dayjs from 'src/libs/dayjs';
import { FULL_MONTH } from 'src/constants/app';

type Props = {
  onClick?: () => void;
  user_pager: Model.UserPager;
};

export default class PublicPager extends Base<Props> {
  render() {
    const { onClick, user_pager } = this.props;

    return (
      <Transition animation="fade down" transitionOnMount duration={500}>
        <Card onClick={onClick} fluid className="p-18 border-primary">
          <div className="d-flex align-center justify-between flex-wrap gap-16">
            <div className="flex-shrink-0">
              <div className="d-flex align-center">
                <Image
                  width={48}
                  height={48}
                  circular
                  className="object-fit-cover flex-shrink-0"
                  src={user_pager.company.logo || company_default}
                />
              </div>
            </div>

            <Card.Content className="flex-1">
              <Card.Header className="mb-8 fs-22">
                {user_pager.company?.name}
              </Card.Header>

              <Card.Description className="d-flex align-center mb-4">
                <User />:
                <span className="ml-4">{user_pager.class_user.user.name}</span>
              </Card.Description>

              <Card.Description className="d-flex align-center mb-4">
                <Calendar />:
                <span className="ml-4">
                  {dayjs(user_pager.submitted_at).format(FULL_MONTH)}
                </span>
              </Card.Description>

              <div className="d-flex gap-16">
                <Card.Description className="d-flex align-center">
                  <Like />
                  <span>{user_pager.avg_vote_value}</span>
                </Card.Description>
                <Card.Description className="d-flex align-center">
                  <CommentBubble />
                  <span>{user_pager.total_comments}</span>
                </Card.Description>
              </div>
            </Card.Content>
          </div>
        </Card>
      </Transition>
    );
  }
}
